import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {SpendingPlanListComponent} from "./components/spending-plan-list/spending-plan-list.component";
import {CreateSpendingPlanComponent} from "./components/create-spending-plan/create-spending-plan.component";
import {ViewSpendingPlanComponent} from "./components/view-spending-plan/view-spending-plan.component";
import {EditSpendingPlanComponent} from "./components/edit-spending-plan/edit-spending-plan.component";

const routes: Routes = [
  {
    path: '',
    component: SpendingPlanListComponent
  },
  {
    path: 'create',
    component: CreateSpendingPlanComponent
  },
  {
    path: 'create/most-recent',
    component: CreateSpendingPlanComponent
  },
  {
    path: ':id',
    component: ViewSpendingPlanComponent
  },
  {
    path: ':id/coach-review',
    component: ViewSpendingPlanComponent
  },
  {
    path: ':id/edit',
    component: EditSpendingPlanComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SpendingPlansRoutingModule { }
